import React from 'react';
import chatIcon from '../images/chatbot.svg';
import closeIcon from '../images/close-icon.svg';
import {unfolder, urlValue} from "../lib";
import { useEffect } from 'react';

class ChatBot extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showChat: 0,
        }
        this.widthContent = 35;
        this.showChatList = this.showChatList.bind(this);
        this.hideChatList = this.hideChatList.bind(this);
    }

    showChatList(){
        this.setState({
            showChat: 1
        });
    }

    hideChatList(){
        this.setState({
            showChat: 0
        });
    }
    
    render() {
        return (
            <div style={{zIndex: 100000000}} >
                <div style={{zIndex: '100', position: 'fixed', right: '3%', bottom: '3%'}}>
                    <button type='button' onClick={this.showChatList}
                            style={{position: 'relative', border: 'none', backgroundColor: 'transparent', cursor: 'pointer'}} >
                        <img src={chatIcon} style={{height: 45, width: 45}} alt=""/>
                    </button>
                </div>
                <div id="content-chat" style={{zIndex: '100', width: '35%', position: 'fixed', right: 0, bottom: 0, display: `${this.state.showChat ? 'block' : 'none'}`}}>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginTop: 13, position: 'fixed', right: 10}}>
                        <button type='button' onClick={this.hideChatList}
                                style={{border: 'none', backgroundColor: 'white', cursor: 'pointer', borderRadius: 25, height: 28, width: 28}}
                                className="d-flex flex-row align-items-center justify-center p-2" >
                            <img src={closeIcon} style={{height: 16, width: 16}} className="m-2" alt="Close" />
                        </button>
                    </div>
        
                    <div style={{width: '100%'}}>
                        <iframe id="chatFrame" src={process.env.REACT_APP_IVA_FACTORY_CHATBOT_URL + `/chatbot?project=${this.props.project.name}&template=nesting_studio`}
                                permissions="geolocation notifications midi"
                           height="600" style={{width: '100%'}} frameBorder="0"/>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChatBot;